import Icon from "../Icon/Icon";

import { TooltipWrapper } from "./TooltipWrapper";

type Props = {
  content: string;
  value: string;
};

const TooltipAlert = ({ content, value }: Props) => {
  return (
    <TooltipWrapper
      delayDuration={0}
      sideOffset={-100}
      contentClassName="whitespace-pre p-4 bg-white text-neutral-muted-on-fill font-semibold rounded-md border border-neutral-muted-border shadow-[0px_2px_4px_-2px_var(--neutral-shadow),0px_4px_6px_-1px_var(--neutral-shadow)]"
      content={content}
    >
      <div className="flex items-center gap-2 whitespace-nowrap bg-error-muted-fill">
        {value}
        <span>
          <Icon iconName="TriangleAlertIcon" size={12} colorVariant="error" />
        </span>
      </div>
    </TooltipWrapper>
  );
};

export default TooltipAlert;
